/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const MCPRequireApproval = {
  Always: "always",
  Never: "never",
} as const;
export type MCPRequireApproval = ClosedEnum<typeof MCPRequireApproval>;

/** @internal */
export const MCPRequireApproval$inboundSchema: z.ZodNativeEnum<
  typeof MCPRequireApproval
> = z.nativeEnum(MCPRequireApproval);
/** @internal */
export const MCPRequireApproval$outboundSchema: z.ZodNativeEnum<
  typeof MCPRequireApproval
> = MCPRequireApproval$inboundSchema;
